/*
 * @Author: cc
 * @Date: 2021-09-30 16:47:05
 * @LastEditTime: 2021-09-30 17:22:35
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\filter\filter.js
 * @Description: 
 */
'use strict';
angular.module('components.filter', [
    'trsToHtmlModule',
    'trsStripBlankModule',
    'trsLimitToModule',
    'trsStrToAbsModule',
    'trsSceModule',
    'trsDataCountsShortenModule',
    'trsDateTransformModule',
    'trsTrustHtmlModule',
    'trsSemicolonToBlankModule',
    'trsWrapModule',
    'trsReplaceSpecharModule',
    'trsToZeroModule',
    'trsTrustAsResourceUrlModule',
    'trsWcmPicModule',
    'trsDocTypeModule',
]);
